module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction/transaction.component.scss
// module id = ./src/app/transaction/transaction.component.scss
// module chunks = main